<template>
  <div class="query-nav">
    <div class="container">
      <div class="field is-grouped is-grouped-right">
        <div class="control is-expanded">
          <form @submit.prevent="onKeywordSearch">
            <input type="text" class="input" name="keywords">
          </form>
        </div>

        <div class="control">
          <div class="select">
            <select v-model="type">
              <option v-for="objectType in ObjectTypes" :key="objectType" :value="objectType">
                {{ objectType | toTitleCase }}
              </option>
            </select>
          </div>
        </div>

        <div class="control">
          <button class="button" @click="setIsEditorOpen(true)" :class="{ 'is-info': isEditorOpen }">
            <fa-icon icon="cog"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <editor
      v-if="isEditorOpen" :query.sync="query.query" :type="type" @close="setIsEditorOpen(false)"
      @input="onQueryChange"
      @input:all="onQueryChange($event, true)"
    ></editor>
  </div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'QueryComponent',

  props: {
    hideUi: {
      required: false
    }
  },

  data () {
    return {
      isEditorOpen: false,
      type: null,
      query: null
    }
  },

  methods: {
    async onKeywordSearch(e) {
      const keywords = e.target.elements.keywords.value

      if (keywords && this.type) {
        const loader = this.$loading.open()
        try {
          const rules = Library.QueryParser.KeywordParser(this.type, keywords)

          const response = await this.$entity.query.paginated(
            this.type,
            {
              rules
            },
            Library.Entities.getIncludes(this.type)
          )

          this.query.query = {
            isLogicalUnion: true,
            rules,
            groups: []
          }
          this.$emit('result', response.data)
          return response.data
        } catch (e) {
          this.$handleError('There was an error running your search', e.response.data)
        } finally {
          loader.close()
        }
      } else {
        if (this.type) {
          this.runQuery()
        }
      }
    },

    setIsEditorOpen (value) {
      this.isEditorOpen = value
    },

    setQuery (query) {
      this.type = query.type
      this.query = query
    },

    async runQuery (page = 0, all = false) {
      const loader = this.$loading.open()

      try {
        const type = this.type

        if (type && this.query) {
          if (all) {
            const response = await this.$entity.query.all(type, this.query.query, Library.Entities.getIncludes(type))

            this.$emit('result', response.data)
            return response.data
          } else {
            const response = await this.$entity.query.paginated(type, this.query.query, Library.Entities.getIncludes(type), 20, page)

            if (page === 0) {
              this.$emit('result', response.data)
            } else {
              this.$emit('amend', response.data)
            }
            return response.data
          }
        }
      } catch (e) {
        throw e
      } finally {
        loader.close()
      }
    },

    onQueryChange (query, all = false) {
      if (this.query) {
        this.query.query = query
      }

      this.runQuery(0)
    }
  },

  computed: {
    ObjectTypes () {
      return Library.Enums.ObjectType
    }
  },

  watch: {
    type (value, oldValue) {
      this.query = new Library.Classes.Query(value)

      if (oldValue) {
        this.$emit('update:type', value)
      }
    }
  },

  components: {
    Editor: Library.Components.Query.Editor
  }
}
</script>

<style lang="scss" scoped>
  .query-nav {
    padding: .5rem 0;
    box-shadow: 0 2px 0 0 whitesmoke;
  }
</style>
